<template>
  <div class='PwRecovery'>
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'PwRecovery'
}
</script>

<style scoped>
.PwRecovery {
  width: 100%;
  height: 100%;
}
</style>
